import { addressParseJobs } from "api/agentJobs";
import { AddressParseJobDto } from "types/api/addressParseJobs";
import { pollAgentJob, PollOutcome as AgentPollOutcome } from "./agentJob";

// Address-parse specialisation of utils/agentJob.ts; the shared pieces the
// address panel and its tests use are re-exported.
export { isAbortError } from "./agentJob";
export { PHOTO_ACCEPT, PHOTO_MAX_BYTES, validatePhoto } from "./photoUpload";

type JobsApi = typeof addressParseJobs;

export type PollOutcome = AgentPollOutcome<
  AddressParseJobDto,
  "parsed" | "failed"
>;

type PollOptions = {
  signal?: AbortSignal;
  jobsApi?: JobsApi;
  intervalMs?: number;
  timeoutMs?: number;
  now?: () => number;
};

export const buildAddressParseFormData = (
  rawInput: string,
  photo: File | null,
): FormData => {
  const body = new FormData();
  const text = rawInput.trim();
  if (text) body.append("raw_input", text);
  if (photo) body.append("image", photo);
  return body;
};

export const createAddressParseJob = (
  body: FormData,
  jobsApi: JobsApi = addressParseJobs,
): Promise<AddressParseJobDto> => jobsApi.create(body);

// Terminal statuses are `parsed` and `failed`; everything else keeps polling.
export const pollAddressParseJob = (
  jobId: number,
  { jobsApi = addressParseJobs, ...options }: PollOptions = {},
): Promise<PollOutcome> =>
  pollAgentJob<AddressParseJobDto, "parsed" | "failed">(jobId, {
    jobsApi,
    terminalStatuses: ["parsed", "failed"],
    ...options,
  });
